import type { FaireProductEntity } from "../../entity_types/product";

export const p_ck8rjyz37h: FaireProductEntity = {
  token: "p_ck8rjyz37h",
  type: "product",
  name: "Wholesale Color-Blocked Women's Sports Yoga Set",
  brandToken: "b_f5yy4uappq",
  brandName: "WONDERXFANS",
  imageUrl:
    "https://cdn.faire.com/fastly/d3981687b0fac607b54275426b8797e266ece35f2eb1d963fade040e1efbbf65.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1366e4a6b666c324cf1cf4d93e051ba574d8673a3cb953675fb421f3e8d64e0c.png",
    "https://cdn.faire.com/fastly/7a45e67d0078cff691f616a9eab08d5d52a77238f5e8919c2217fb60b063d42e.png",
    "https://cdn.faire.com/fastly/c15ecd31161e60fa210dcb373425949381b4f63c913395f1ca69c88455c9f056.png",
    "https://cdn.faire.com/fastly/863d12543062c189c8021024ec335eb3fe16cacf0ba9df32535d05e2e8cc1829.png",
    "https://cdn.faire.com/fastly/91e116717a184aa7f56ec94e429575efd66071b2f4c11b85df78f9ca5e56b017.png",
    "https://cdn.faire.com/fastly/a9a854e37f83307a4b50c99335a5b3084d81a7185454201165f6579f64466852.png",
    "https://cdn.faire.com/fastly/e39a244e66fb46a3137b91c8f8a4a55f98173253ad7f0351f8e3a180ad4b4366.png",
    "https://cdn.faire.com/fastly/c7a2a98e580863cf44dd2027cfabdb9ae4c599f1a297060065c4dc4528cc50b8.png",
    "https://cdn.faire.com/fastly/8328c5b534ebb86c09735861a0201202f04e2cf23ac017bdbcbc3f9b2b86ee6d.png",
    "https://cdn.faire.com/fastly/6383160f79743649242b9d7edcb869efa75f4eb6d0e196546c8ad1eebbb67ab3.png",
    "https://cdn.faire.com/fastly/94e99389343b9a30ee57b91a1334a14e918058830b0609814f3af60ff43f80c2.png",
    "https://cdn.faire.com/fastly/31a8b4927b2e54f2565e44cba44ccf8cafdc9588f5817e198b51a80df19116a2.png",
  ],
  priceDollars: 10.99,
  description:
    "[Design Details]\n• Women's sports set includes a color-block crop top and high-waisted leggings\nUnique Design Points:\n• Straight from our production line to you. Enjoy factory-direct quality yoga wear.\n[Fabric details]\nFabric Composition:\n• 90% Nylon +10% Spandex\nFabric Features:\n• So buttery soft and fit body\n• Four-way stretch\n• Durable and shape-retaining\n[Fit & Feel]\n• Normal\n• Skin-friendly\n[Function Details]\n• Medium stretch for entry-level training\n[Suitable for exercise]\n• Training\n• Yoga \n",
  tags: [],
  msrpDollars: 32.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:34.155Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
